module.exports = __webpack_public_path__ + "static/media/burger-menu-icon-white.7f156a14.svg";